module.exports = __webpack_public_path__ + "static/media/people.ccd3cc42.svg";